import React from 'react';
import { Link } from 'react-router-dom';
import Div from '../Div';
import './post.scss';

export default function PostStyle2({ thumb, title, subtitle, date, category, categoryHref }) {
  return (
    <Div className="cs-post cs-style2" data-aos="fade-up" data-aos-duration="2000">
      <Link to="#" className="cs-post_thumb cs-radius_15">
        <img
          src={thumb}
          alt="Post"
          className="w-100 cs-radius_15"
          style={{ height: '80vh', objectFit: 'cover', borderRadius: '15px' }}
        />
      </Link>
      <Div className="cs-post_info">
        <Div className="cs-post_meta cs-style1 cs-ternary_color cs-semi_bold cs-primary_font">
          <span className="cs-posted_by">{date}</span>
          <Link to={categoryHref} className="cs-post_avatar">{category}</Link>
        </Div>
        <h2 className="cs-post_title">{title}</h2>
        {/* Show full descriptions with line breaks */}
        {Array.isArray(subtitle) ? (
          subtitle.map((desc, idx) => (
            <p key={idx} className="cs-post_sub_title" style={{ marginBottom: '1.5rem' }}>
              {desc}
            </p>
          ))
        ) : (
          <p className="cs-post_sub_title">{subtitle}</p>
        )}
      </Div>
    </Div>
  );
}
